import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../_components/Button";
import { formatCurrencyValue, decimalFormat, checkIfBranchExists } from "../../../utils";
import CurrencyInput from "react-currency-input"

import Autocomplete from "./components/AutoComplete";
import TableItems from "./components/TableItems";
import SaleResume from "./components/SaleResume";

import checkNFCeConfig from "./checkNFCeConfig";
import { saveSaleOnStorage, getSaleFromStorage, updateClientToSale } from "./helpers"

import FooterActionsPOS from "./components/FooterActionsPOS";
import POSContext from "./context"
import ImportPOSWithAI from "./components/ImportPOSWithAI";
import AIEmitButton from "../../../components/AIEmitButton";
export default class POS extends React.Component {
  constructor(props) {
    super(props);
    console.debug("[POS Constructor] Inicializando componente POS");
    
    checkIfBranchExists()
    
    this.state = {
      loading: false,
      currentBranch: { branch_plan: {}, fiscal_config: {} },
      sale: { total_amount: 0, discount_value: 0, discount_type: "cash", items: [], payments: [], cpf_cnpj: "" },
      currentObj: { error: "", editType: "quantity", inputValue: 0 },
      discount: { showModal: false },
      allowSendNFCe: false,
      modalItemWithoutFiscalData: false,
      showAIModal: false
    };
    
    console.debug("[POS Constructor] Estado inicial:", this.state);
    
    this.onRemoveItem = this.onRemoveItem.bind(this);
    this._goToPayment = this._goToPayment.bind(this)
    this._onSetClient = this._onSetClient.bind(this)
    this._removeClient = this._removeClient.bind(this)
    this._onSetDiscountType = this._onSetDiscountType.bind(this)
    this._onChangeInputDiscount = this._onChangeInputDiscount.bind(this)
    this._onSetDiscount = this._onSetDiscount.bind(this)
    this._updateItemQuantity = this._updateItemQuantity.bind(this)
    this._openModalUpdateItemQuantity = this._openModalUpdateItemQuantity.bind(this)
    this._closeModalUpdateItemQuantity = this._closeModalUpdateItemQuantity.bind(this)
    this._closeModalItemWithOutFiscalData = this._closeModalItemWithOutFiscalData.bind(this)
    this._onPressEnterModalQuantity = this._onPressEnterModalQuantity.bind(this)
    this._openModalUpdateItemPrice = this._openModalUpdateItemPrice.bind(this);
    this._handleModalInputChange = this._handleModalInputChange.bind(this);
    this._saveModalValue = this._saveModalValue.bind(this);
    this._onSetCPF = this._onSetCPF.bind(this)
    this._removeCPF = this._removeCPF.bind(this)
    this.handleApplyAIData = this.handleApplyAIData.bind(this)
    
    console.debug("[POS Constructor] Bindings concluídos");
  }
  
  _onSetClient(client) {
    console.debug("[POS _onSetClient] Cliente recebido:", client);
    
    const saleUpdated = updateClientToSale(client)
    console.debug("[POS _onSetClient] Venda atualizada com cliente:", saleUpdated);
    
    this._setState({ sale: saleUpdated })
  }
  
  _removeClient() {
    console.debug("[POS _removeClient] Removendo cliente da venda");
    
    const saleUpdated = updateClientToSale({}, true)
    console.debug("[POS _removeClient] Venda atualizada sem cliente:", saleUpdated);
    
    this._setState({ sale: saleUpdated })
  }

  _onSetCPF(cpf) {
    console.debug("[POS _onSetCPF] CPF recebido:", cpf);
    const { sale } = this.state
    sale.cpf_cnpj = cpf
    this._setState({ sale })
  }

  _removeCPF() {
    console.debug("[POS _removeCPF] Removendo CPF");
    const { sale } = this.state
    sale.cpf_cnpj = ""
    this._setState({ sale })
  }
  
  _onSetDiscountType(e) {
    console.debug("[POS _onSetDiscountType] Evento recebido:", e.target.name);
    
    const { name: discountType } = e.target
    const { sale } = this.state
    
    console.debug("[POS _onSetDiscountType] Tipo de desconto anterior:", sale.discount_type);
    console.debug("[POS _onSetDiscountType] Novo tipo de desconto:", discountType);
    
    sale["discount_type"] = discountType
    this._setState({ sale: sale })
  }
  
  _onChangeInputDiscount(stringValue, doubleValue, event) {
    console.debug("[POS _onChangeInputDiscount] Valores recebidos:", { stringValue, doubleValue });
    
    const { sale } = this.state
    console.debug("[POS _onChangeInputDiscount] Venda atual:", sale);
    console.debug("[POS _onChangeInputDiscount] Total da venda:", sale.total_amount);
    console.debug("[POS _onChangeInputDiscount] Desconto atual:", sale.discount_value);
    
    if (doubleValue > sale.total_amount - sale.discount_value) {
      console.debug("[POS _onChangeInputDiscount] Valor de desconto maior que o permitido - ignorando");
      return
    }
    
    sale["discount_value_input"] = doubleValue
    console.debug("[POS _onChangeInputDiscount] Novo valor de desconto input:", doubleValue);
    
    this._setState({ sale: sale })
  }
  
  _onSetDiscount() {
    console.debug("[POS _onSetDiscount] Aplicando desconto");
    
    const { sale } = this.state
    console.debug("[POS _onSetDiscount] Venda antes do desconto:", sale);
    console.debug("[POS _onSetDiscount] Tipo de desconto:", sale.discount_type);
    console.debug("[POS _onSetDiscount] Valor input do desconto:", sale.discount_value_input);

    const discount_value = sale["discount_type"] === "cash"
      ? sale.discount_value_input
      : sale.total_amount * (sale.discount_value_input / 100)

    console.debug("[POS _onSetDiscount] Valor calculado do desconto:", discount_value);

    sale["discount_value"] = decimalFormat(discount_value, 3)
    console.debug("[POS _onSetDiscount] Valor formatado do desconto:", sale.discount_value);

    const discount = {
      showModal: false
    }
    
    console.debug("[POS _onSetDiscount] Fechando modal de desconto");
    this._setState({ sale: sale, discount })
  }

  _openModalUpdateItemPrice(item) {
    console.debug("[POS _openModalUpdateItemPrice] Abrindo modal de preço para item:", item);
    
    const currentPrice = item.item_sale_price != null
      ? item.item_sale_price
      : item.sellable.price;

    console.debug("[POS _openModalUpdateItemPrice] Preço atual do item:", currentPrice);

    this.setState({
      currentObj: {
        ...item,
        showModal: true,
        error: "",
        editType: "price",
        inputValue: currentPrice
      }
    });
    
    console.debug("[POS _openModalUpdateItemPrice] Estado atualizado:", this.state.currentObj);
    this._focusModalInput();
  }

  _openModalUpdateItemQuantity(item) {
    console.debug("[POS _openModalUpdateItemQuantity] Abrindo modal de quantidade para item:", item);
    console.debug("[POS _openModalUpdateItemQuantity] Quantidade atual:", item.quantity);
    
    this.setState({
      currentObj: {
        ...item,
        showModal: true,
        error: "",
        editType: "quantity",
        inputValue: item.quantity
      }
    })
    
    console.debug("[POS _openModalUpdateItemQuantity] Estado atualizado:", this.state.currentObj);
    this._focusModalInput();
  }

  _focusModalInput() {
    console.debug("[POS _focusModalInput] Tentando focar input do modal");
    
    setTimeout(() => {
      try {
        const input = document.getElementById("input-change-item-quantity");
        console.debug("[POS _focusModalInput] Input encontrado:", input);
        
        if (input) {
          input.focus();
          console.debug("[POS _focusModalInput] Input focado com sucesso");
        } else {
          console.debug("[POS _focusModalInput] Input não encontrado no DOM");
        }
      } catch (error) {
        console.debug("[POS _focusModalInput] Erro ao focar input:", error);
      }
    }, 100)
  }

  _handleModalInputChange(maskedValue, doubleValue, event) {
    console.debug("[POS _handleModalInputChange] Valores recebidos:", { maskedValue, doubleValue });
    
    const { currentObj } = this.state
    console.debug("[POS _handleModalInputChange] Objeto atual antes:", currentObj);
    
    currentObj.inputValue = doubleValue
    console.debug("[POS _handleModalInputChange] Novo valor do input:", doubleValue);
    
    this.setState({ currentObj })
  }

  _closeModalUpdateItemQuantity() {
    console.debug("[POS _closeModalUpdateItemQuantity] Fechando modal de atualização");
    
    this.setState({
      currentObj: { error: "" }
    })
    
    console.debug("[POS _closeModalUpdateItemQuantity] Modal fechado");
  }

  _onPressEnterModalQuantity(e) {
    console.debug("[POS _onPressEnterModalQuantity] Tecla pressionada:", e.key);
    
    if (e.key === "Enter") {
      console.debug("[POS _onPressEnterModalQuantity] Enter detectado - salvando valor");
      this._saveModalValue()
    }
  }
  
  _saveModalValue() {
    console.debug("[POS _saveModalValue] Salvando valor do modal");
    
    const { sale, currentObj } = this.state
    console.debug("[POS _saveModalValue] Venda atual:", sale);
    console.debug("[POS _saveModalValue] Objeto atual:", currentObj);
    console.debug("[POS _saveModalValue] Tipo de edição:", currentObj.editType);
    console.debug("[POS _saveModalValue] Valor a ser salvo:", currentObj.inputValue);

    for (let x = 0; x < sale.items.length; x++) {
      const item = sale.items[x]
      
      if (item.id === currentObj.id) {
        console.debug("[POS _saveModalValue] Item encontrado no índice:", x);
        console.debug("[POS _saveModalValue] Item antes da atualização:", item);
        
        if (currentObj.editType === "quantity") {
          sale.items[x].quantity = currentObj.inputValue || 1
          console.debug("[POS _saveModalValue] Quantidade atualizada para:", sale.items[x].quantity);
        } else if (currentObj.editType === "price") {
          sale.items[x].item_sale_price = currentObj.inputValue || 0
          console.debug("[POS _saveModalValue] Preço atualizado para:", sale.items[x].item_sale_price);
        }
        
        console.debug("[POS _saveModalValue] Item após atualização:", sale.items[x]);
      }
    }

    console.debug("[POS _saveModalValue] Venda final após atualizações:", sale);

    this._setState({
      sale,
      currentObj: {
        ...currentObj,
        error: "",
        showModal: false,
      }
    })

    this._setPOSAutocompleteInputFocus()
  }

  _updateItemQuantity(maskedValue, doubleValue, event) {
    console.debug("[POS _updateItemQuantity] Atualizando quantidade:", { maskedValue, doubleValue });
    
    const { currentObj } = this.state
    console.debug("[POS _updateItemQuantity] Objeto atual:", currentObj);
    
    currentObj.quantity = decimalFormat(doubleValue)
    console.debug("[POS _updateItemQuantity] Nova quantidade formatada:", currentObj.quantity);
    
    this.setState({ ...this, currentObj })
  }
  
  _goToPayment() {
    console.debug("[POS _goToPayment] Redirecionando para página de pagamento");
    console.debug("[POS _goToPayment] Venda atual:", this.state.sale);
    
    window.location.href = "/pos/payment";
  }
  
  addItemToSale(item) {
    console.debug("[POS addItemToSale] Adicionando item à venda:", item);
    
    const { sale } = this.state
    console.debug("[POS addItemToSale] Venda atual:", sale);
    console.debug("[POS addItemToSale] Permitir envio NFCe:", this.state.allowSendNFCe);

    if (this.state.allowSendNFCe) {
      console.debug("[POS addItemToSale] Verificando dados fiscais do item");
      
      let error = ""
      if (item.fiscal_data) {
        const { fiscal_data } = item
        const { ncm, cfop, template_icms } = fiscal_data
        
        console.debug("[POS addItemToSale] Dados fiscais encontrados:", { ncm, cfop, template_icms });
        
        if (!ncm.code || !cfop.code || !template_icms.csosn) {
          console.debug("[POS addItemToSale] Dados fiscais incompletos");
          
          if (!ncm.code) {
            error += "SEM ICMS;"
            console.debug("[POS addItemToSale] Falta NCM");
          }
          if (!cfop.code) {
            error += "SEM CFOP;"
            console.debug("[POS addItemToSale] Falta CFOP");
          }
          if (!template_icms.csosn) {
            error += "SEM NCM"
            console.debug("[POS addItemToSale] Falta CSOSN");
          }
          
          const currentObj = {
            name: item.sellable.name,
            error,
            id: item.id
          }
          
          console.debug("[POS addItemToSale] Exibindo modal de erro fiscal:", currentObj);
          this.setState({ ...this, currentObj, modalItemWithoutFiscalData: true })
          return
        }

      } else {
        console.debug("[POS addItemToSale] Item sem dados fiscais");
        
        const currentObj = {
          name: item.sellable.name,
          error: "Nenhuma informação fiscal",
          id: item.id
        }
        
        console.debug("[POS addItemToSale] Exibindo modal de erro fiscal:", currentObj);
        this.setState({ ...this, currentObj, modalItemWithoutFiscalData: true })
        return
      }
    }
    
    item.quantity = 1
    item.item_sale_price = item.sellable.price
    
    console.debug("[POS addItemToSale] Item preparado:", { quantity: item.quantity, price: item.item_sale_price });

    // Verifica se item já existe na venda
    for (let x = 0; x < sale.items.length; x++) {
      if (sale.items[x].id === item.id) {
        console.debug("[POS addItemToSale] Item já existe na venda - incrementando quantidade");
        console.debug("[POS addItemToSale] Quantidade antes:", sale.items[x].quantity);
        
        sale.items[x].quantity += 1
        
        console.debug("[POS addItemToSale] Quantidade depois:", sale.items[x].quantity);
        
        this._setState({ sale: sale })
        return
      }
    }
    
    console.debug("[POS addItemToSale] Item novo - adicionando à venda");
    
    sale
      .items
      .push({
        ...item,
        cfop: undefined
      })
      
    console.debug("[POS addItemToSale] Total de itens na venda:", sale.items.length);
    console.debug("[POS addItemToSale] Venda após adicionar item:", sale);
    
    this._setState({ sale: sale })
    this._setPOSAutocompleteInputFocus()
  }
  
  _setPOSAutocompleteInputFocus() {
    console.debug("[POS _setPOSAutocompleteInputFocus] Focando input de busca");
    
    try {
      const input = document.getElementById("pos-search-items-autocomplete");
      console.debug("[POS _setPOSAutocompleteInputFocus] Input encontrado:", input);
      
      if (input) {
        input.focus();
        console.debug("[POS _setPOSAutocompleteInputFocus] Input focado com sucesso");
      } else {
        console.debug("[POS _setPOSAutocompleteInputFocus] Input não encontrado no DOM");
      }
    } catch (error) {
      console.debug("[POS _setPOSAutocompleteInputFocus] Erro ao focar input:", error);
    }
  }
  
  _closeModalItemWithOutFiscalData() {
    console.debug("[POS _closeModalItemWithOutFiscalData] Fechando modal de dados fiscais");
    
    this.setState({
      currentObj: { error: "" },
      modalItemWithoutFiscalData: false
    })
    
    console.debug("[POS _closeModalItemWithOutFiscalData] Modal fechado");
  }

  updateTotal() {
    console.debug("[POS updateTotal] Iniciando atualização do total");
    
    setTimeout(() => {
      const { sale } = this.state
      console.debug("[POS updateTotal] Venda atual:", sale);
      console.debug("[POS updateTotal] Número de itens:", sale.items.length);
      
      let totalAmount = 0;
      
      for (let x = 0; x < sale.items.length; x++) {
        const obj = sale.items[x];
        console.debug(`[POS updateTotal] Processando item ${x + 1}/${sale.items.length}:`, obj);
        
        const unitPrice = obj.item_sale_price != null
          ? obj.item_sale_price
          : obj.sellable.price;

        console.debug(`[POS updateTotal] Item ${x + 1} - Preço unitário:`, unitPrice);
        console.debug(`[POS updateTotal] Item ${x + 1} - Quantidade:`, obj.quantity);

        const total = (unitPrice * obj.quantity).toFixed(4);
        console.debug(`[POS updateTotal] Item ${x + 1} - Total bruto:`, total);
        
        const totalFormatted = decimalFormat(total, 2);
        console.debug(`[POS updateTotal] Item ${x + 1} - Total formatado:`, totalFormatted);
        
        totalAmount += totalFormatted;
        console.debug(`[POS updateTotal] Total acumulado:`, totalAmount);
      }
      
      sale.total_amount = totalAmount;
      console.debug("[POS updateTotal] Total final da venda:", sale.total_amount);
      console.debug("[POS updateTotal] Salvando venda no storage");

      saveSaleOnStorage(this.state.sale)
      console.debug("[POS updateTotal] Venda salva no storage");
      
      this.setState({ ...this, sale })
      console.debug("[POS updateTotal] Estado atualizado");
    }, 100)
  }
  
  setDiscount() {
    console.debug("[POS setDiscount] Abrindo modal de desconto");
    
    this.setState({
      modalDiscountState: true,
    });
    
    console.debug("[POS setDiscount] Modal de desconto aberto");
  }

  onRemoveItem(e) {
    console.debug("[POS onRemoveItem] Removendo item");
    console.debug("[POS onRemoveItem] Evento:", e.target);
    
    const { id } = e.target
    console.debug("[POS onRemoveItem] ID do item a remover:", id);
    
    let { sale } = this.state;
    console.debug("[POS onRemoveItem] Venda antes da remoção:", sale);
    console.debug("[POS onRemoveItem] Total de itens antes:", sale.items.length);
    
    sale.items = sale.items.filter(item => item.id != id)
    console.debug("[POS onRemoveItem] Total de itens após remoção:", sale.items.length);
    
    if (sale.items.length === 0) {
      console.debug("[POS onRemoveItem] Venda ficou vazia - resetando");
      
      sale = {
        "discount_value_input": 0,
        "total_amount": 0,
        "discount_value": 0,
        "paid_value": "",
        "change": "",
        "items": [],
        "payments": []
      }
      
      console.debug("[POS onRemoveItem] Venda resetada:", sale);
    }
    
    sale = { sale: sale }
    console.debug("[POS onRemoveItem] Estado a ser atualizado:", sale);
    
    this._setState(sale);
  }
  
  _loadStorageSale() {
    console.debug("[POS _loadStorageSale] Carregando venda do storage");
    
    let saleFromStorage = getSaleFromStorage()
    console.debug("[POS _loadStorageSale] Venda recuperada do storage:", saleFromStorage);
    
    const defaultSale = {
      total_amount: 0,
      discount_value: 0,
      discount_type: "cash",
      items: [],
      payments: []
    };
    
    console.debug("[POS _loadStorageSale] Venda padrão:", defaultSale);
    
    const sale = saleFromStorage || defaultSale;
    console.debug("[POS _loadStorageSale] Venda a ser carregada:", sale);
    console.debug("[POS _loadStorageSale] Usando storage?", !!saleFromStorage);
    
    this.setState({ sale }, () => {
      console.debug("[POS _loadStorageSale] Estado atualizado com venda do storage");
      console.debug("[POS _loadStorageSale] Atualizando total");
      this.updateTotal()
    })
  }
  
  _setState(newState) {
    console.debug("[POS _setState] Atualizando estado");
    console.debug("[POS _setState] Novo estado:", newState);
    console.debug("[POS _setState] Estado anterior:", this.state);
    
    this.setState(newState, () => {
      console.debug("[POS _setState] Estado atualizado com sucesso");
      console.debug("[POS _setState] Estado atual completo:", this.state);
      
      if (this.state.sale) {
        console.debug("[POS _setState] Salvando venda no storage");
        console.debug("[POS _setState] Venda a ser salva:", this.state.sale);
        
        saveSaleOnStorage(this.state.sale)
        console.debug("[POS _setState] Venda salva no storage");
      } else {
        console.debug("[POS _setState] Sem venda para salvar no storage");
      }
      
      console.debug("[POS _setState] Atualizando total");
      this.updateTotal();
    })
  }

  handleApplyAIData(extractedData, options) {
    console.debug("[POS handleApplyAIData] Recebendo dados da IA:", extractedData, options);
    const { sale } = this.state;
    
    // Atualizar itens
    if (extractedData.items && extractedData.items.length > 0) {
      extractedData.items.forEach(item => {
        // Formatar para o formato de item do carrinho PDV
        const posItem = {
          ...item,
          id: item.original_id || item.id,
          sellable: {
            ...(item.product || {}),
            price: item.unit_price,
            name: item.name || (item.product && item.product.name) || "Produto",
            sku: item.product && item.product.sku
          },
          item_sale_price: item.unit_price,
          quantity: item.quantity || 1,
          discount: item.discount_amount || 0,
          fiscal_data: item.product ? item.product.fiscal_data : undefined,
          cfop: undefined,
          icms: undefined,
          ipi: undefined,
          pis: undefined,
          cofins: undefined
        };
        
        let existingIndex = sale.items.findIndex(i => i.id === posItem.id && i.id != null);
        if (existingIndex > -1) {
            sale.items[existingIndex].quantity += posItem.quantity;
        } else {
            sale.items.push(posItem);
        }
      });
    }

    // Atualizar cliente
    if (extractedData.recipient) {
      const recipient = extractedData.recipient;
      if (recipient.original_id) {
        // Se a IA encontrou o cliente no banco, setamos ele completo
        sale.client_name = recipient.name;
        sale.cpf_cnpj = recipient.document || recipient.cpf_cnpj;
        sale.client = recipient.original_id;
      } else if (recipient.document || recipient.cpf_cnpj) {
        // Senão, apenas colocamos o CPF
        sale.cpf_cnpj = recipient.document || recipient.cpf_cnpj;
      }
    }

    // Atualizar pagamentos
    if (extractedData.payments && extractedData.payments.length > 0) {
      sale.payments = extractedData.payments.map(p => ({
        value: p.value,
        displayValue: formatCurrencyValue(p.value),
        paymentName: p.name,
        payment_method: p.payment_method
      }));
    }

    this._setState({ sale: sale });
    
    if (options && options.autoEmit) {
      setTimeout(() => {
        this.props.history.push("/pos/payment", { autoEmit: true });
      }, 500);
    }
  }

  _checkAllowSendNFCe() {
    console.debug("[POS _checkAllowSendNFCe] Verificando permissão para envio de NFCe");
    
    const allowSendNFCe = checkNFCeConfig()
    console.debug("[POS _checkAllowSendNFCe] Resultado da verificação:", allowSendNFCe);
    
    this.setState({ allowSendNFCe })
    console.debug("[POS _checkAllowSendNFCe] Estado atualizado");
  }

  componentDidMount() {
    console.debug("[POS componentDidMount] Componente montado");
    console.debug("[POS componentDidMount] Carregando venda do storage");
    
    this._loadStorageSale()
    
    console.debug("[POS componentDidMount] Verificando configuração NFCe");
    this._checkAllowSendNFCe()
    
    console.debug("[POS componentDidMount] Inicialização concluída");
  }

  render() {
    console.debug("[POS render] Renderizando componente");
    console.debug("[POS render] Estado atual:", this.state);
    
    const discount = formatCurrencyValue(this.state.sale.discount_value)
    const subTotal = formatCurrencyValue(this.state.sale.total_amount)
    const total = formatCurrencyValue(this.state.sale.total_amount - this.state.sale.discount_value)
    
    console.debug("[POS render] Valores calculados:", { discount, subTotal, total });
    
    return <POSContext.Provider value={this.state.sale}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <Autocomplete onClick={this.addItemToSale.bind(this)} />
            <div className="mb-3 mt-2">
                <AIEmitButton onClick={() => this.setState({ showAIModal: true })} />
            </div>
            <TableItems
              onAddItems={this.addItemToSale}
              onRemoveItem={this.onRemoveItem}
              openModalDiscount={this._openModalUpdateItemQuantity}
              openModalPrice={this._openModalUpdateItemPrice}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <SaleResume
              subTotal={subTotal}
              discountValue={discount}
              totalAmount={total}
            />
          </div>
        </div>

        <FooterActionsPOS
          onSetClient={this._onSetClient}
          removeClient={this._removeClient}
          onChangeInputDiscount={this._onChangeInputDiscount}
          onSetDiscountType={this._onSetDiscountType}
          onSetDiscount={this._onSetDiscount}
          onSetCPF={this._onSetCPF}
          removeCPF={this._removeCPF}
        />
        <Modal
          show={this.state.currentObj.showModal}
          onHide={this._closeModalUpdateItemQuantity}>
          <Modal.Header closeButton>
            <Modal.Title>
              Modificar {this.state.currentObj.editType === 'price' ? 'o valor' : 'a quantidade'} do item
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <CurrencyInput
              onKeyDown={this._onPressEnterModalQuantity}
              className="form-control"
              id="input-change-item-quantity"
              onChange={this._handleModalInputChange}
              value={this.state.currentObj.inputValue || 0}
              decimalSeparator=","
              thousandSeparator="."
              precision="2" />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this._saveModalValue}>
              Atualizar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Modal show={this.state.modalItemWithoutFiscalData} size="lg" onHide={this._closeModalItemWithOutFiscalData}>
        <Modal.Header closeButton>
          <Modal.Title>
            Item sem informações fiscais
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="lead">O item "{this.state.currentObj.name}" não possui informações como:</p>
          <ul className="list-group">
            {
              this.state.currentObj.error.split(";").map((error, index) => {
                const key = `modal-pos-error-item-without-fiscal-data-${error}-${index}`
                return <li
                  key={key}
                  className="list-group-item">
                  <div className="badge badge-primary">{error}</div>
                </li>
              })
            }
          </ul>
          <p>
            clique <a href={`/product/${this.state.currentObj.id}`}>aqui</a> para editar o item
          </p>
        </Modal.Body>
      </Modal>

      <ImportPOSWithAI 
        show={this.state.showAIModal} 
        onHide={() => this.setState({ showAIModal: false })} 
        onApplyData={this.handleApplyAIData} 
      />
    </POSContext.Provider>
  }
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/index.jsx